import React, { memo } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Spacer } from 'design-system';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { selectPotToDisplayInOnboardingFunnel } from '../reducers/selectors';
import AccountCreatedProgressCard from './AccountCreatedProgressCard';
import CreateFirstPotProgressCard from './CreateFirstPotProgressCard';
import Header from './Header';
import SetupAutosaveProgressCard from './SetupAutosaveProgressCard';
import UnderReviewProgressCard from './UnderReviewProgressCard';
const OnboardingFunnel = ({ status }) => {
    const hasPostOpenInstructions = useAppSelector((state) => state.pots.hasPostOpenInstructions);
    const pot = useAppSelector(selectPotToDisplayInOnboardingFunnel);
    if (hasPostOpenInstructions) {
        return (<View testID="PotsOnboardingFunnel">
        <Header status={status}/>
        <ProgressCard title={`${pot ? pot.name : 'Pot'} created`} completed lightBg/>
        <ProgressCard title="Autosave set up" completed lightBg/>
        <UnderReviewProgressCard status={status} lastItem/>
        <Spacer h={16}/>
      </View>);
    }
    return (<View testID="PotsOnboardingFunnel">
      <Header status={status}/>
      <AccountCreatedProgressCard />
      <UnderReviewProgressCard status={status}/>
      <CreateFirstPotProgressCard status={status}/>
      <SetupAutosaveProgressCard />
      <Spacer h={16}/>
    </View>);
};
export default memo(OnboardingFunnel);
